var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c(
      "div",
      { staticClass: "floating-actions__button" },
      [
        _c("CompassIconButton", {
          attrs: { type: "primary", icon: "check" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.save($event)
            }
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "floating-actions__button" },
      [
        _c("CompassIconButton", {
          attrs: { icon: "close" },
          on: {
            click: function($event) {
              $event.stopPropagation()
              return _vm.cancel($event)
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }